import { Notification } from '@app/components'
import { HexContract } from 'libs/data/contracts'
import { EHEX_ADDRESS } from 'libs/ethereum/constants'

import useWrite from './useWrite'

/** Transfer eHEX on Ethereum to the inventory (send) wallet. Does not use PulseChain burn dest. */
export default function useEhexSell(amountHuman: number, depositAddress: string, onHash: (hash: string) => void) {
  const raw = BigInt(Math.round(Number(amountHuman || 0) * 1e8))
  const enabled = Boolean(depositAddress && /^0x[a-fA-F0-9]{40}$/.test(depositAddress) && amountHuman > 0)

  return useWrite({
    waitForReceipt: true,
    contract: (EHEX_ADDRESS || HexContract.address) as `0x${string}`,
    abi: HexContract.abi,
    functionName: 'transfer',
    loading: false,
    enabled,
    args: [depositAddress || '0x0000000000000000000000000000000000000001', raw],
    onTransactionComplete: (hash: string) => {
      if (hash) {
        onHash(hash)
        Notification({ message: 'eHEX received — crediting USD', type: 'info' })
      }
    },
  })
}
